import qs from 'qs';
import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { I18nNameSpaces } from 'common/services/i18n';
import { PasswordEditFormValues } from 'common/models/User';
import { PasswordEditForm } from 'common/forms';

import { AuthPageDescription } from '../../../../components';
import { changePasswordActions } from '../../ducks';

function ForgottenPasswordRecoveryFeature() {
  const { t } = useTranslation(I18nNameSpaces.Auth);
  const dispatch = useDispatch();
  const recoveryPage = 'forgottenPassword.recovery.page';

  function handleSubmit({ password }: PasswordEditFormValues) {
    const { token } = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });

    dispatch(changePasswordActions.request({ password, token: token as string }));
  }

  return (
    <Row justify="center">
      <Col xs={24} md={8}>
        <AuthPageDescription title={t(`${recoveryPage}.title`)} description={t(`${recoveryPage}.description`)} />
        <PasswordEditForm onSubmit={handleSubmit} />
      </Col>
    </Row>
  );
}

export default ForgottenPasswordRecoveryFeature;
